<div class="logout" *ngIf="loaded">
  <div class="logout-outer">
    <div class="logout-middle">
      <div class="logout-inner">
        <p class="logout-inner-text">Vous êtes déconnecté</p>
        <div class="logout-inner-login">
          <lib-andromeda-button (click)="redirectToHome()"
            >Se connecter</lib-andromeda-button
          >
        </div>
      </div>
    </div>
  </div>
</div>
